import Stickyd from './Stickyd';


new Stickyd({
    minWidth: 768,
    offset: 40
});


const initAsides = function(){
    

};
